"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleResultPaginationLoadMore = void 0;
const react_1 = __importDefault(require("react"));
const ExampleResultPaginationLoadMore = (props) => {
    return (react_1.default.createElement("button", { className: "rs__pagination__loadmore-button", onClick: () => props.handleLoadMore(), disabled: !props.hasMore }, "Load more"));
};
exports.ExampleResultPaginationLoadMore = ExampleResultPaginationLoadMore;
//# sourceMappingURL=ExampleResultPaginationLoadMore.js.map